import React from 'react';
import { useSelector } from 'react-redux';
import { Module } from './Module';
import styles from './Steps.module.sass';

export const Steps = () => {
  const steps = useSelector((state) => state.get('route').get('steps'))?.toJS() || [];

  return (
    <div className={styles.Steps}>
      <div className={`${styles.Modules}`}>
        {steps.map((step, index) => (
          <Module key={`Module-${index}`} {...step} />
        ))}
      </div>
    </div>
  );
};
